import { EditPDP } from './EditPDP';

export default EditPDP;
